// Helpers for typing an Aadhaar number: it is stored as 12 plain digits and shown in groups of four ("1234 5678 9012").
export const AADHAAR_PLACEHOLDER = '•••• •••• ••••'; // bullets read larger than middle dots

export const aadhaarDigits = (value) => String(value || '').replace(/\D/g, '').slice(0, 12);

export const formatAadhaar = (value) => aadhaarDigits(value).replace(/(\d{4})(?=\d)/g, '$1 ');

// '' when the number is fine (or still empty); otherwise a short message to show under the box.
// A real Aadhaar number is 12 digits and never starts with 0 or 1.
export const aadhaarError = (value, { whileTyping = true } = {}) => {
    const digits = aadhaarDigits(value);
    if (!digits) return '';
    if (/^[01]/.test(digits)) return 'An Aadhaar number never starts with 0 or 1';
    if (digits.length < 12) return whileTyping ? '' : `Enter all 12 digits (${digits.length}/12)`;
    return '';
};
